export const API_BASE_URL_ENV = () => {
	return "https://back.popcorny.net/api";
};
